export default () => ({
  playing: false,
  isMobile: null,

  init() {
    this.setIsMobile();
  },

  play() {
    this.playing = true;
  },

  stop() {
    this.playing = true;
  },

  setIsMobile() {
    this.isMobile = window.innerWidth < 1024 ? true : false;
  },
});
